<template>
  <div class="dashboard">
    <div v-if="dataPlan.tipoPlano !== 'gestao_personalizado'" class="dashboard-shell">
      <header class="dashboard-header">
        <div>
          <p>Aqui está o resumo da sua gestão para a data selecionada.</p>
        </div>
        <div class="dashboard-header__actions">
          <button
            class="dashboard-visibility-toggle"
            type="button"
            :aria-label="dashboardValuesToggleLabel"
            :title="dashboardValuesToggleLabel"
            @click="toggleDashboardValues"
          >
            <b-icon-eye v-if="isDashboardValuesVisible" />
            <b-icon-eye-slash v-else />
          </button>
          <label class="date-filter" aria-label="Filtro de data do dashboard">
            <b-icon-calendar2-week />
            {{ dashboardDateLabel }}
            <b-icon-chevron-down />
            <input
              class="date-filter__input"
              type="date"
              v-model="selectedDashboardDate"
              @change="refreshDashboardByDate"
            />
          </label>
        </div>
      </header>

      <section class="metrics-grid" aria-label="Indicadores principais">
        <DashboardCard
          v-for="card in dashboardCards"
          :key="card.title"
          :title="card.title"
          :value="formatDashboardValue(card.value)"
          :loading="spinGeneral"
          :success="card.success"
          :to="card.to"
        >
          <template #icon>
            <component :is="card.icon" />
          </template>
        </DashboardCard>
      </section>

      <section class="charts-grid" v-if="userLevel === 'adm'">
        <article class="dashboard-panel">
          <div class="panel-header">
            <div>
              <h2>Contas a Pagar e Contas a Receber</h2>
            </div>
            <button class="period-select" type="button">
              Este mês
              <b-icon-chevron-down />
            </button>
          </div>
          <GraphicLine
            :selected-date="selectedDashboardDate"
            :hide-values="!isDashboardValuesVisible"
          />
        </article>

        <article class="dashboard-panel">
          <div class="panel-header">
            <h2>Resumo por Categoria</h2>
            <b-icon-info-circle class="panel-info" />
          </div>
          <GraphicBar
            :selected-date="selectedDashboardDate"
            :hide-values="!isDashboardValuesVisible"
          />
        </article>
      </section>

      <section class="charts-grid" v-else>
        <article class="dashboard-panel dashboard-panel--empty">
          <b-icon-exclamation-triangle-fill />
          <span>Sem Informações</span>
        </article>
        <article class="dashboard-panel dashboard-panel--empty">
          <b-icon-exclamation-triangle-fill />
          <span>Sem Informações</span>
        </article>
      </section>

      <section class="dashboard-bottom-grid">
        <article class="dashboard-panel shortcuts-panel">
          <div class="panel-header">
            <h2>Atalhos principais</h2>
          </div>
          <div class="shortcuts-grid">
            <DashboardShortcutCard
              v-for="shortcut in dashboardShortcuts"
              :key="shortcut.title"
              :title="shortcut.title"
              :description="shortcut.description"
              :to="shortcut.to"
            >
              <template #icon>
                <component :is="shortcut.icon" />
              </template>
            </DashboardShortcutCard>
          </div>
        </article>

        <aside class="dashboard-panel activities-panel">
          <div class="panel-header">
            <h2>Últimas Atividades</h2>
            <router-link :to="{ path: '/configuracoes', query: { tela: 'registros' } }">
              Ver todas
            </router-link>
          </div>
          <div v-if="spinActivities" class="activities-state">
            <b-spinner small />
            <span>Carregando registros...</span>
          </div>
          <div v-else-if="!activityItems.length" class="activities-state">
            <b-icon-clock-history />
            <span>Nenhuma atividade recente encontrada.</span>
          </div>
          <ul v-else class="activity-list">
            <ActivityItem
              v-for="activity in activityItems"
              :key="activity.id"
              :title="activity.title"
              :description="activity.description"
              :time="activity.time"
              :tone="activity.tone"
            >
              <template #icon>
                <component :is="activity.icon" />
              </template>
            </ActivityItem>
          </ul>
        </aside>
      </section>

      <div class="containerSchedule" v-if="lentscheduleDay > 0">
        <div class="btnSchedule buttonToOpenSideCommon" @click="sideOpenCompany">
          <b-icon-calendar2-week class="buttonToOpenSideCommon" />
          <div class="countEvents buttonToOpenSideCommon">
            {{ lentscheduleDay }}
          </div>
        </div>
        <div :class="`${contentSideOCompany}`">
          <span class="titleSchedule">Eventos do dia</span>
          <div
            :class="sideOCompany"
            v-for="scheduleDay in allScheduleDay"
            :key="scheduleDay.id"
          >
            <div class="hourSchedule">
              <span>{{ scheduleDay.dataAgenda.split(" ")[1].slice(0, 5) }}</span>
            </div>
            <div>
              <span>{{ scheduleDay.tipo }}</span>
              <span class="descriptionSchedule">{{ scheduleDay.descricao }}</span>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="modalterms"
        hide-footer
        hide-header
        centered
        no-close-on-backdrop
        title="Terms"
      >
        <div class="contentTerms">
          <div class="titleTerms">Termos & Condições</div>
          <img class="imgTerms" loading="lazy" :src="searchRocket" />
          <div class="textTerms">
            <p>
              Para continuar, por favor, aceite os nossos termos e condições.
            </p>
            <p>
              É crucial que você os leia e compreenda antes de prosseguir com o
              uso dos nossos serviços. Para acessar o documento completo
              contendo todas as cláusulas
              <a
                class="linkPdf"
                href="https://nfe-web-termo.s3.sa-east-1.amazonaws.com/ContratoUsuario.pdf"
                target="_blank"
                rel="noopener noreferrer"
                >clique aqui.</a
              >
            </p>
            <div class="checkbox-wrapper-46">
              <input
                type="checkbox"
                v-model="termsAccepted"
                id="cbx-46"
                class="inp-cbx"
              />
              <label for="cbx-46" class="cbx">
                <span>
                  <svg viewBox="0 0 12 10" height="10px" width="12px">
                    <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                  </svg>
                </span>
                <span class="checkbox">Concordo com os termos e condições.</span>
              </label>
            </div>
          </div>
          <div class="btnModalTerms">
            <button
              class="btnContent"
              @click="updateTerms(termsAccepted)"
              :disabled="!termsAccepted"
            >
              Confirmar
            </button>
            <button
              class="btnContent btnContent--light"
              @click="$bvModal.hide('modalterms')"
            >
              Pergunte-me depois
            </button>
          </div>
        </div>
      </b-modal>
    </div>

    <div class="restrict" v-else>
      <div class="textTester">
        <img src="../../assets/logoBG.png" class="logo" alt="" />
        <p>Adquira seu plano para liberar mais funcionalidades.</p>
        <ul>
          <li>Whatsapp 1: (31) 3891-9414</li>
          <li>Email: suporte@bmssoftwares.com.br</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../services/axios";
import moment from "moment";
import "moment/locale/pt";
import searchRocket from "../../assets/searchRocket.png";
import GraphicLine from "./GraphicLine.vue";
import GraphicBar from "./GraphicBar.vue";
import DashboardCard from "./DashboardCard.vue";
import DashboardShortcutCard from "./DashboardShortcutCard.vue";
import ActivityItem from "./ActivityItem.vue";
import { TypeSale } from "../../utils/enums/SalesType";
import serviceGestao from "../../services/serviceGestao";
import { mapState } from "vuex";

export default {
  components: {
    GraphicLine,
    GraphicBar,
    DashboardCard,
    DashboardShortcutCard,
    ActivityItem,
  },
  data() {
    return {
      typeSale: TypeSale,
      searchRocket: searchRocket,
      spinGeneral: false,
      spinActivities: false,
      termsAccepted: false,
      totalDayFront: 0,
      totalDaySale: 0,
      totalDayBudget: 0,
      totalMTQSales: 0,
      totalMTQBudget: 0,
      totalMonthSale: "",
      selectedDashboardDate: moment().format("YYYY-MM-DD"),
      collapsed: false,
      userLevel: "",
      sideOCompany: "disabledContent",
      contentSideOCompany: "disabledContent",
      allScheduleDay: [],
      activityLogs: [],
      lentscheduleDay: 0,
      monthIndex: parseInt(moment().format("MM")),
      receivedSummary: {
        expireToday: 0,
        sumMatury: 0,
      },
      payableSummary: {
        expireToday: 0,
        sumMatury: 0,
      },
      isDashboardValuesVisible:
        localStorage.getItem("dashboardValuesVisible") !== "false",
    };
  },
  methods: {
    formatCurrency(value) {
      return Number(value || 0).toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    },

    formatDashboardValue(value) {
      if (!this.isDashboardValuesVisible) {
        return "R$ •••••";
      }

      return this.formatCurrency(value);
    },

    toggleDashboardValues() {
      this.isDashboardValuesVisible = !this.isDashboardValuesVisible;
      localStorage.setItem(
        "dashboardValuesVisible",
        String(this.isDashboardValuesVisible)
      );
    },

    async filterBillPerMonth() {
      try {
        this.spinGeneral = true;
        const selectedDate = moment(this.selectedDashboardDate);
        const selectedDay = selectedDate.format("YYYY-MM-DD");
        const monthStart = selectedDate.clone().startOf("month").format("YYYY-MM-DD");
        const monthEnd = selectedDate.clone().endOf("month").format("YYYY-MM-DD");

        const [
          receiveDaySummary,
          payableDaySummary,
          receiveMonthSummary,
          payableMonthSummary,
        ] = await Promise.all([
          this.getBillSummaryFromList("entrada", selectedDay, selectedDay),
          this.getBillSummaryFromList("saida", selectedDay, selectedDay),
          this.getBillSummaryFromList("entrada", monthStart, monthEnd, true),
          this.getBillSummaryFromList("saida", monthStart, monthEnd, true),
        ]);

        this.receivedSummary.expireToday = receiveDaySummary.expireToday;
        this.receivedSummary.sumMatury = receiveMonthSummary.sumMatury;
        this.payableSummary.expireToday = payableDaySummary.expireToday;
        this.payableSummary.sumMatury = payableMonthSummary.sumMatury;
      } catch (error) {
        console.log(error);
      } finally {
        this.spinGeneral = false;
      }
    },

    async getBillSummaryFromList(kind, startDate, endDate = startDate, usePeriodTotal = false) {
      const pageSize = 9;
      let page = 1;
      let hasNextPage = true;
      let expireToday = 0;
      let sumMatury = 0;

      while (hasNextPage) {
        const qs = [
          `startDate=${startDate}`,
          `endDate=${endDate}`,
          `typeBill=${kind}`,
          "q=",
          "collumnSearch=",
          "idCategoryBill=",
          "status=",
          `page=${page}`,
        ].join("&");
        const { data } = await api.get(`/bills/list/bills/?${qs}`);
        const bills = Array.isArray(data?.bills) ? data.bills : [];

        if (usePeriodTotal) {
          sumMatury = this.toNumber(data?.sumBills);
        }

        expireToday += bills.reduce((total, bill) => {
          return total + this.toNumber(bill.valorRestante);
        }, 0);

        if (!usePeriodTotal) {
          sumMatury = this.toNumber(data?.vencidas);
        }

        hasNextPage = bills.length === pageSize;
        page += 1;
      }

      return {
        expireToday,
        sumMatury,
      };
    },

    sideOpenCompany() {
      this.collapsed = !this.collapsed;
      this.contentSideOCompany = this.collapsed
        ? "contentSchedule"
        : "disabledContent";
      this.sideOCompany = this.collapsed ? "rowScedule" : "disabledContent";
    },

    handleClickOutside(event) {
      const sideCommonElement = this.$el.querySelector(".contentSchedule");

      if (
        sideCommonElement &&
        !sideCommonElement.contains(event.target) &&
        !event.target.classList.contains("buttonToOpenSideCommon")
      ) {
        this.collapsed = false;
        this.sideOCompany = "disabledContent";
        this.contentSideOCompany = "disabledContent";
      }
    },

    async filterSalePerDay() {
      try {
        const { data } = await api.get(
          `/sales/per/day/search/sum/group/dashboard/initial?date=${this.selectedDashboardDate}`
        );
        const sales = data?.data ?? [];

        this.totalDayFront =
          this.getDashboardTotal(sales, "totalBoxFront") ||
          this.getTotalSaleByType(sales, this.typeSale.frenteDeCaixa);
        this.totalDaySale =
          this.getDashboardTotal(sales, "totalSale") ||
          this.getTotalSaleByType(sales, this.typeSale.venda);
        this.totalDayBudget =
          this.getDashboardTotal(sales, "totalBudget") ||
          this.getTotalSaleByType(sales, this.typeSale.orcamento);

        const salesFromList = await this.getSalesTotalsFromList(
          "/sales",
          this.selectedDashboardDate
        );

        if (salesFromList.totalItems) {
          this.totalDayFront = salesFromList.totalFront;
          this.totalDaySale = salesFromList.totalSale;
          this.totalDayBudget = salesFromList.totalBudget;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async filterSaleMTQPerDay() {
      try {
        const { data } = await api.get(
          `/sales-square-meter/per/day/search/sum/group/dashboard/initial?date=${this.selectedDashboardDate}`
        );
        const sales = data?.data ?? [];

        this.totalMTQSales =
          this.getDashboardTotal(sales, "totalSaleSquareMeter") ||
          this.getTotalSaleMTQByType(sales, this.typeSale.venda);
        this.totalMTQBudget =
          this.getDashboardTotal(sales, "totalBudgetSquareMeter") ||
          this.getTotalSaleMTQByType(sales, this.typeSale.orcamento);

        const salesFromList = await this.getSalesTotalsFromList(
          "/sales-square-meter",
          this.selectedDashboardDate
        );

        if (salesFromList.totalItems) {
          this.totalMTQSales = salesFromList.totalSale;
          this.totalMTQBudget = salesFromList.totalBudget;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getSalesTotalsFromList(endpoint, date) {
      const pageSize = 9;
      let page = 1;
      let hasNextPage = true;
      const totals = {
        totalFront: 0,
        totalSale: 0,
        totalBudget: 0,
        totalItems: 0,
      };

      while (hasNextPage) {
        const { data } = await api.get(
          `${endpoint}?q=&type=&page=${page}&startDate=${date}&endDate=${date}`
        );
        const items = Array.isArray(data?.data) ? data.data : [];

        items.forEach((sale) => {
          if (sale.situacao === "Cancelado(a)") return;

          const value = this.toNumber(sale.valorTotal);

          if (sale.tipo === this.typeSale.frenteDeCaixa) {
            totals.totalFront += value;
          } else if (sale.tipo === this.typeSale.venda || sale.status === this.typeSale.venda) {
            totals.totalSale += value;
          } else if (
            sale.tipo === this.typeSale.orcamento ||
            sale.status === this.typeSale.orcamento
          ) {
            totals.totalBudget += value;
          }
        });

        totals.totalItems += items.length;
        hasNextPage = items.length === pageSize;
        page += 1;
      }

      return totals;
    },

    async refreshDashboardByDate() {
      await Promise.all([
        this.filterBillPerMonth(),
        this.filterSalePerDay(),
        this.filterSaleMTQPerDay(),
      ]);
    },

    async getDaySchedules() {
      try {
        const { data } = await api.get("schedules/get/schedules/day/");
        this.allScheduleDay = data;
        this.lentscheduleDay = data.length;
      } catch (error) {
        console.log(error);
      }
    },

    async getRecentActivityLogs() {
      try {
        this.spinActivities = true;
        const { data } = await api.get(
          "/produtos-logs/filter?type=&page=1&q=&limit=5"
        );

        this.activityLogs = Array.isArray(data?.data) ? data.data : [];
      } catch (error) {
        console.log(error);
        this.activityLogs = [];
      } finally {
        this.spinActivities = false;
      }
    },

    getTotalSaleByType(sales, type) {
      if (!Array.isArray(sales)) return 0;

      return sales
        .filter((sale) => sale.tipo === type && sale.situacao != "Cancelado(a)")
        .reduce((total, sale) => total + this.toNumber(sale.valorTotalMonth), 0);
    },

    getTotalSaleMTQByType(sales, status) {
      if (!Array.isArray(sales)) return 0;

      return sales
        .filter(
          (sale) => sale.status === status && sale.situacao != "Cancelado(a)"
        )
        .reduce((total, sale) => total + this.toNumber(sale.valorTotalMonth), 0);
    },

    getDashboardTotal(data, key) {
      if (Array.isArray(data)) {
        return this.toNumber(data[0]?.[key]);
      }

      return this.toNumber(data?.[key]);
    },

    toNumber(value) {
      const number = Number(value);
      return Number.isFinite(number) ? number : 0;
    },

    getActivityTitle(activity) {
      const titles = {
        movManual: "Alteração manual no estoque",
        movManualGeral: "Alteração manual no estoque geral",
        vinculadoFrente: "Produto vinculado ao frente de caixa",
        vinculadoVenda: "Produto vinculado à venda",
        deletadoVenda: "Produto removido da venda",
        deletadoCompra: "Produto removido da compra",
        atualizadoVenda: "Produto atualizado na venda",
        cancelamentoVenda: "Venda cancelada com retorno ao estoque",
        compra: "Produto adicionado via compra",
        nota: "Produto movimentado em documento fiscal",
        devolucaoNota: "Devolução fiscal com retorno ao estoque",
        cancelamentoNota: "Documento fiscal cancelado com retorno ao estoque",
      };

      return titles[activity?.descricao] || "Registro atualizado";
    },

    getActivityIcon(activity) {
      const icons = {
        movManual: "b-icon-pencil-square",
        movManualGeral: "b-icon-pencil-square",
        vinculadoFrente: "b-icon-cart4",
        vinculadoVenda: "b-icon-cart4",
        deletadoVenda: "b-icon-arrow-counterclockwise",
        deletadoCompra: "b-icon-arrow-counterclockwise",
        atualizadoVenda: "b-icon-arrow-repeat",
        cancelamentoVenda: "b-icon-arrow-counterclockwise",
        compra: "b-icon-box-seam",
        nota: "b-icon-receipt",
        devolucaoNota: "b-icon-arrow-counterclockwise",
        cancelamentoNota: "b-icon-arrow-counterclockwise",
      };

      return icons[activity?.descricao] || "b-icon-clock-history";
    },

    getActivityTone(activity) {
      const from = this.toNumber(activity?.dados?.from);
      const to = this.toNumber(activity?.dados?.to);
      if (to >= from) {
        return "green";
      }

      if (["nota", "atualizadoVenda"].includes(activity?.descricao)) {
        return "blue";
      }

      return "purple";
    },

    getActivityQuantity(activity) {
      const from = this.toNumber(activity?.dados?.from);
      const to = this.toNumber(activity?.dados?.to);
      const difference = to - from;

      return Math.abs(difference);
    },

    getActivityDescription(activity) {
      const productName = activity?.nome || "Produto sem nome";
      const quantity = this.getActivityQuantity(activity);
      const stock = activity?.estoqueAtual;
      const details = [`Produto: ${productName}`];

      if (quantity) {
        details.push(`Qtd: ${quantity}`);
      }

      if (stock !== undefined && stock !== null) {
        details.push(`Estoque: ${stock}`);
      }

      return details.join(" - ");
    },

    formatActivityTime(createdAt) {
      const activityDate = moment(createdAt);

      if (!activityDate.isValid()) {
        return "";
      }

      if (activityDate.isSame(moment(), "day")) {
        return `Hoje, ${activityDate.format("HH:mm")}`;
      }

      if (activityDate.isSame(moment().subtract(1, "day"), "day")) {
        return `Ontem, ${activityDate.format("HH:mm")}`;
      }

      return activityDate.format("DD/MM/YYYY");
    },

    async updateTerms(contract) {
      try {
        const token = localStorage.getItem("token");
        await serviceGestao.updateTerms(token, contract);
        this.$bvModal.hide("modalterms");
        this.$store.commit("DATA_CONTRACT", contract);
        this.$toast.open({
          message: "Contrato atualizado com sucesso!",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message: error,
          type: "info",
        });
      }
    },

    checkUserLevel() {
      this.userLevel = localStorage.getItem("userLevel");
    },

    handleDataContractChange() {
      if (this.dataContract === false) {
        this.$bvModal.show("modalterms");
      } else {
        this.$bvModal.hide("modalterms");
      }
    },
  },
  async created() {
    this.checkUserLevel();
    await this.filterBillPerMonth(this.monthName);
    await this.filterSalePerDay();
    await this.filterSaleMTQPerDay();
    await this.getDaySchedules();
    await this.getRecentActivityLogs();
  },
  computed: {
    ...mapState(["dataContract", "enableMtq", "dataPlan", "dataCompany"]),
    companyName() {
      return this.dataCompany?.nome || "BMS LTDA";
    },
    dashboardDateLabel() {
      return moment(this.selectedDashboardDate).format("DD/MM/YYYY");
    },
    dashboardValuesToggleLabel() {
      return this.isDashboardValuesVisible
        ? "Ocultar valores do dashboard"
        : "Visualizar valores do dashboard";
    },
    dashboardCards() {
      return [
        {
          title: "Vendas do Dia",
          value: this.totalDayFront + this.totalDaySale,
          icon: "b-icon-cart4",
          to: {
            path: "/vendas",
            query: {
              type: "tipo",
              q: this.typeSale.venda,
            },
          },
        },
        {
          title: "Vendas MT² do Dia",
          value: this.totalMTQSales,
          icon: "b-icon-bar-chart-line",
          to: {
            path: "/vendas",
            query: {
              type: "tipo",
              q: this.typeSale.venda,
            },
          },
        },
        {
          title: "Orçamentos do Dia",
          value: this.totalDayBudget,
          icon: "b-icon-clipboard-check",
          to: {
            path: "/vendas",
            query: {
              type: "tipo",
              q: this.typeSale.orcamento,
            },
          },
        },
        {
          title: "Orçamentos MT² do Dia",
          value: this.totalMTQBudget,
          icon: "b-icon-clipboard-data",
          to: {
            path: "/vendas",
            query: {
              type: "tipo",
              q: this.typeSale.orcamento,
            },
          },
        },
        {
          title: "A receber hoje",
          value: this.receivedSummary.expireToday,
          icon: "b-icon-arrow-down-short",
          to: "/financeiro",
        },
        {
          title: "Recebimentos do Mês",
          value: this.receivedSummary.sumMatury,
          icon: "b-icon-clock",
          success: true,
          to: "/financeiro",
        },
        {
          title: "Pagamentos do Mês",
          value: this.payableSummary.sumMatury,
          icon: "b-icon-credit-card",
          success: true,
          to: "/financeiro",
        },
        {
          title: "A pagar hoje",
          value: this.payableSummary.expireToday,
          icon: "b-icon-cash-stack",
          to: "/financeiro",
        },
      ];
    },
    dashboardShortcuts() {
      return [
        {
          title: "Nova Venda",
          description: "Cadastre uma nova venda de produtos ou serviços.",
          icon: "b-icon-cart4",
          to: {
            path: "/vendas",
            query: {
              type: "tipo",
              q: this.typeSale.venda,
            },
          },
        },
        {
          title: "Novo Orçamento",
          description: "Crie um novo orçamento para seus clientes.",
          icon: "b-icon-file-earmark-text",
          to: {
            path: "/vendas",
            query: {
              type: "tipo",
              q: this.typeSale.orcamento,
            },
          },
        },
        {
          title: "Emissão Fiscal",
          description: "Emita NF-e, NFC-e e outros documentos.",
          icon: "b-icon-file-earmark-richtext",
          to: "/fiscal",
        },
        {
          title: "Financeiro",
          description: "Acesse contas, recebimentos e pagamentos.",
          icon: "b-icon-cash-stack",
          to: "/financeiro",
        },
      ];
    },
    activityItems() {
      return this.activityLogs
        .slice()
        .sort((current, next) => {
          return (
            moment(next.createdAt).valueOf() -
            moment(current.createdAt).valueOf()
          );
        })
        .slice(0, 5)
        .map((activity, index) => ({
          id: activity.uuid || activity.id || `${activity.createdAt}-${index}`,
          title: this.getActivityTitle(activity),
          description: this.getActivityDescription(activity),
          time: this.formatActivityTime(activity.createdAt),
          icon: this.getActivityIcon(activity),
          tone: this.getActivityTone(activity),
        }));
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    this.handleDataContractChange();
  },

  watch: {
    dataContract() {
      this.handleDataContractChange();
    },
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.dashboard {
  width: 100%;
  min-height: 100vh;
  margin-left: 60px;
  padding: 82px 42px 48px;
  background: #f7f4ff;
}

.dashboard-shell {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  padding: 0 0 4px;
}

.dashboard-header p {
  margin: 0;
  color: #66638c;
  font-size: 15px;
}

.dashboard-header__actions {
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
  gap: 12px;
  flex-wrap: wrap;
  padding-top: 0;
}

.accounting-button,
.user-button,
.dashboard-visibility-toggle,
.date-filter,
.period-select {
  height: 42px;
  min-height: 42px;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 0;
  border-radius: 9px;
  color: #17105c;
  background: #ffffff;
  box-shadow: 0 12px 24px rgba(34, 31, 84, 0.06);
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
  padding: 0 18px;
}

.dashboard-visibility-toggle {
  height: 42px;
  width: 42px;
  flex: 0 0 42px;
  margin: 0;
  padding: 0;
  cursor: pointer;
  font-size: 17px;
  line-height: 1;
}

.dashboard-visibility-toggle:hover {
  color: #5b2ee8;
}

.dashboard-visibility-toggle svg {
  display: block;
}

.accounting-button:hover {
  color: #17105c;
  text-decoration: none;
}

.user-button {
  width: 72px;
  padding: 0;
}

.date-filter {
  position: relative;
  margin-left: auto;
  cursor: pointer;
}

.date-filter__input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px;
}

.charts-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

.dashboard-panel {
  min-width: 0;
  min-height: 380px;
  padding: 22px;
  border: 1px solid rgba(71, 48, 134, 0.06);
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 18px 40px rgba(31, 28, 92, 0.06);
}

.dashboard-panel--empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #f2a83e;
  font-weight: 700;
}

.panel-header {
  min-height: 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}

.panel-header h2 {
  margin: 0;
  color: #12105d;
  font-size: 16px;
  line-height: 1.25;
  font-weight: 800;
}

.panel-header a {
  color: #4f2bde;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
}

.panel-info {
  color: #6b6795;
}

.period-select {
  min-height: 34px;
  padding: 0 13px;
  border: 1px solid #ece8fb;
  font-size: 12px;
}

.dashboard-bottom-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(360px, 0.65fr);
  gap: 18px;
}

.shortcuts-panel,
.activities-panel {
  min-height: 286px;
}

.shortcuts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}

.activity-list {
  margin: 0;
  padding: 0;
}

.activities-state {
  min-height: 190px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #706c9a;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
}

.restrict {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.textTester {
  color: #00486e;
}

.textTester ul {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.containerSchedule {
  display: flex;
  flex-direction: column;
  position: fixed;
  bottom: 24px;
  width: 300px;
  height: 50vh;
  right: 24px;
  align-items: center;
  justify-content: center;
  z-index: 1100;
}

.btnSchedule {
  cursor: pointer;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  bottom: 0;
  right: 0;
  border-radius: 50%;
  color: #ffffff;
  background: #4b20ce;
  box-shadow: 0 14px 28px rgba(75, 32, 206, 0.3);
}

.countEvents {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -6px;
  right: -4px;
  background: #ff2d55;
  color: white;
  font-size: 10px;
  border-radius: 50%;
  width: 20px;
  height: 20px;
}

.contentSchedule {
  width: 260px;
  height: 100%;
  max-height: 50vh;
  overflow: auto;
  display: flex;
  position: absolute;
  background: white;
  right: 10px;
  bottom: 64px;
  border: none;
  border-radius: 12px;
  flex-direction: column;
  align-items: center;
  padding: 8px;
  z-index: 1000;
  box-shadow: 0 18px 40px rgba(31, 28, 92, 0.16);
  transition: ease-in all 0.3s;
}

.disabledContent {
  height: 0;
  width: 250px;
  position: absolute;
  visibility: hidden;
  transition: ease-in all 0.3s;
}

.titleSchedule {
  font-size: 14px;
  text-align: center;
  padding: 10px 0;
  font-weight: 700;
}

.descriptionSchedule {
  color: #818181;
  font-size: 12px !important;
  font-style: normal !important;
  font-weight: 100 !important;
  display: flex;
  flex-wrap: wrap;
}

.rowScedule {
  width: 100%;
  padding: 7px;
  border-radius: 8px;
  border: 1px solid #ece8fb;
  gap: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.hourSchedule {
  font-size: 15px;
  padding: 8px;
  border-radius: 50px;
  background: #f3efff;
}

.rowScedule span {
  font-weight: bold;
  font-size: 13px;
  display: flex;
  margin-bottom: 0 !important;
}

.contentTerms {
  display: flex;
  height: 70vh;
  position: relative;
  flex-direction: column;
  align-items: center;
}

.titleTerms {
  font-size: 23px;
  text-align: center;
}

.textTerms {
  display: flex;
  flex-direction: column;
  text-align: justify;
  font-size: 12px;
  gap: 20px;
  font-weight: bold;
  overflow: auto;
  padding: 30px 40px 20px;
}

.checkbox-wrapper-46 input[type="checkbox"] {
  display: none;
  visibility: hidden;
}

.checkbox-wrapper-46 .cbx {
  margin: auto;
  user-select: none;
  cursor: pointer;
}

.checkbox-wrapper-46 .cbx span {
  display: inline-block;
  vertical-align: middle;
  transform: translate3d(0, 0, 0);
}

.checkbox-wrapper-46 .cbx span:first-child {
  position: relative;
  width: 18px;
  height: 18px;
  border-radius: 3px;
  transform: scale(1);
  vertical-align: middle;
  border: 1px solid #9098a9;
  transition: all 0.2s ease;
}

.checkbox-wrapper-46 .cbx span:first-child svg {
  position: absolute;
  top: 3px;
  left: 2px;
  fill: none;
  stroke: #ffffff;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 16px;
  stroke-dashoffset: 16px;
  transition: all 0.3s ease;
  transition-delay: 0.1s;
  transform: translate3d(0, 0, 0);
}

.checkbox-wrapper-46 .cbx span:first-child:before {
  content: "";
  width: 100%;
  height: 100%;
  background: #506eec;
  display: block;
  transform: scale(0);
  opacity: 1;
  border-radius: 50%;
}

.checkbox-wrapper-46 .cbx span:last-child {
  padding-left: 8px;
}

.checkbox-wrapper-46 .cbx:hover span:first-child {
  border-color: #506eec;
}

.checkbox-wrapper-46 .inp-cbx:checked + .cbx span:first-child {
  background: #00486e;
  border-color: #506eec;
  animation: wave-46 0.4s ease;
}

.checkbox-wrapper-46 .inp-cbx:checked + .cbx span:first-child svg {
  stroke-dashoffset: 0;
}

.checkbox-wrapper-46 .inp-cbx:checked + .cbx span:first-child:before {
  transform: scale(3.5);
  opacity: 0;
  transition: all 0.6s ease;
}

@keyframes wave-46 {
  50% {
    transform: scale(0.9);
  }
}

.linkPdf {
  color: #007bff !important;
  text-decoration: underline;
  text-transform: uppercase;
}

.imgTerms {
  width: 275px;
  height: 150px;
  padding-right: 30px;
}

.btnModalTerms {
  width: 100%;
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 0;
  justify-content: space-around;
}

.btnContent {
  font-size: 11px;
  border: 1px solid #00486e;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #00486e;
}

.btnContent--light {
  background: whitesmoke;
  color: black;
}

@media screen and (max-width: 1500px) {
  .dashboard-bottom-grid {
    grid-template-columns: minmax(0, 1fr) minmax(340px, 0.58fr);
  }

  .shortcuts-grid {
    grid-template-columns: repeat(2, minmax(220px, 1fr));
  }
}

@media screen and (max-width: 1320px) {
  .dashboard-bottom-grid,
  .charts-grid {
    grid-template-columns: 1fr;
  }

  .shortcuts-grid {
    grid-template-columns: repeat(2, minmax(240px, 1fr));
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .dashboard {
    margin-left: 50px;
    padding: 76px 26px 26px;
  }

  .metrics-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media screen and (max-width: 745px) {
  .dashboard {
    margin-left: 0;
    padding: 24px 18px 40px;
  }

  .dashboard-header {
    flex-direction: column;
  }

  .dashboard-header__actions {
    width: 100%;
    justify-content: flex-start;
  }

  .date-filter {
    flex-basis: auto;
    margin-left: 0;
  }

  .metrics-grid,
  .shortcuts-grid {
    grid-template-columns: 1fr;
  }

  .dashboard-panel {
    min-height: 320px;
    padding: 18px;
  }

  .dashboard-bottom-grid {
    grid-template-columns: 1fr;
  }

  .containerSchedule {
    right: 18px;
    bottom: 18px;
  }
}
</style>
